import { createDate } from "@/utils";
import { type Dayjs } from "dayjs";
import { atom, useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { ATOM_KEY } from "../keys";

const checkCountAtom = atom({
    default: 0,
    key: ATOM_KEY.CHECK_COUNT,
});

const firstCheckInAtom = atom({
    default: true,
    key: ATOM_KEY.CHECK_FIRST,
});

const maxDateAtom = atom<Dayjs | undefined>({
    default: undefined,
    key: ATOM_KEY.CHECK_MAX,
});

const checkInAtom = atom({
    default: createDate().currentDateInfo,
    key: ATOM_KEY.CHECK_IN,
});

const checkOutAtom = atom({
    default: createDate(0, 1).currentDateInfo || undefined,
    key: ATOM_KEY.CHECK_OUT,
});

const checkFakeAtom = atom({
    default: createDate(0, 1).currentDateInfo,
    key: ATOM_KEY.CHECK_FAKE,
});

export const useCheckCountState = () => useRecoilState(checkCountAtom);
export const useCheckCountValue = () => useRecoilValue(checkCountAtom);

export const useCheckInState = () => useRecoilState(checkInAtom);
export const useCheckInValue = () => useRecoilValue(checkInAtom);

export const useCheckOutState = () => useRecoilState(checkOutAtom);
export const useCheckOutValue = () => useRecoilValue(checkOutAtom);

export const useSetCheckFakeState = () => useSetRecoilState(checkFakeAtom);
export const useCheckFakeValue = () => useRecoilValue(checkFakeAtom);

export const useCheckFirstState = () => useRecoilState(firstCheckInAtom);
export const useCheckMaxState = () => useRecoilState(maxDateAtom);
